export enum AdditionalEmployeeStatus {
  OverPlanned = 'OVER_PLANNED',
  Away = 'AWAY',
  Proposal = 'PROPOSAL',
}
